// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"rx","delete_item":"sx","subscription_item":"tx","subscription_item_img_wrapper":"ux","subscription_item_info":"vx","subscription_item_title":"wx","subscription_item_edit":"xx","subscription_item_wrapper":"yx","arrow":"zx","subscription_item_category":"Ax","plus_button":"Bx","more_details":"Cx","old_price":"Ex","discount":"Fx"};
    if(module.hot) {
      // 1713969932017
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  